export function shouldShowLessonMaterialsCheatSheet(
  isEducatorCaregiverLessonLayout?: boolean | null,
  hasRequiredMaterials = true,
): boolean {
  return !!hasRequiredMaterials && !isEducatorCaregiverLessonLayout;
}
